module.exports = __webpack_public_path__ + "static/media/amusement(11).83a8c39e.PNG";